import { render } from "./getuiadd.vue?vue&type=template&id=2d2044bf&scoped=true"
import script from "./getuiadd.vue?vue&type=script&lang=js"
export * from "./getuiadd.vue?vue&type=script&lang=js"

import "./getuiadd.vue?vue&type=style&index=0&id=2d2044bf&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2044bf"]])

export default __exports__